import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 15000 });

export const getConfig = async () => {
  const { data } = await http.get("/config");
  return data;
};

export const getQuote = async (payload) => {
  const { data } = await http.post("/quote", payload);
  return data;
};

export const createBooking = async (payload) => {
  const { data } = await http.post("/bookings", payload);
  return data;
};

export const listBookings = async () => {
  const { data } = await http.get("/bookings");
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await http.post("/contact", payload);
  return data;
};

export const listContact = async () => {
  const { data } = await http.get("/contact");
  return data;
};

export const getFlightStatus = async (payload) => {
  const { data } = await http.post("/flight-status", payload);
  return data;
};
